import { useEffect } from 'react';

declare global {
    interface Window {
        dataLayer: unknown[];
        gtag: (...args: unknown[]) => void;
    }
}

interface GoogleAnalyticsProps {
    gaCode: string;
}

export function GoogleAnalytics({ gaCode }: GoogleAnalyticsProps) {
    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.gtag = function gtag(...args: unknown[]) {
            window.dataLayer.push(args);
        };

        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${gaCode}`;
        document.head.appendChild(script);

        window.gtag('js', new Date());
        window.gtag('config', gaCode);
    }, [gaCode]);

    return null;
}
